import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Pythonsidebar';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";

function Pstring(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
 
return(
     <div>
<Sides/>
<Helmet>
 
  <title>Learn Free Python String Beginners Tutorials CodeExampler</title>
<meta name="description" content="Python String tutorial for beginners.String in Python is the name of a memory location in which we can store the text " />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,python string array,python string format,python string formatter,python string split,python string compare,string to int python,python string to int,python string length,python string reverse,python string methods,
python string replace,python string contains,python string equals,python string substring,python string indexof,python string index,python string concatenation,python string class,python string array to list" />
<link rel="canonical" href="https://www.codeexampler.com/python-string/"/>
</Helmet>

<div className='lg:pl-56'>

<h1 className="m-4 mh1">Python String</h1>

<div className="first">
        <a href="/python-operators">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-control-structure">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>


<p className="mt-4 para">1, String in Python is the name of a memory location in which we can store the Text<br/>
2, In Python Text of string in python, can be changed<br/>
3, Text or character enclosed by double quotes<br/>
4, Create a variable of string Type
 <br/>
</p>


<h2 className='headings'>Python Simple String Example :</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">hello CodeExampler</span>
                 <span className="qwerty-1">")</span>
             {"\n"}
             {"\n"}
                  </code>
         </pre>
         </div> 
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                        <span className="qwerty-2">hello CodeExampler</span>
                    {"\n"}
                    {"\n"}
              </code>
                </pre>
                </div>



<h2 className='headings'>Q-Write a Program Print 2 Names in Python String Example Code?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1"> ="</span>
                 <span className="qwerty-2">Ram</span>
                 <span className="qwerty-1">"</span>
             {"\n"}
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1"> ="</span>
                 <span className="qwerty-2">Lakshman</span>
                 <span className="qwerty-1">"</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">b</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
             {"\n"}
                  </code>
         </pre>
         </div> 
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                        <span className="qwerty-10">Ram</span>
                    {"\n"}
                        <span className="qwerty-10">Lakshman</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div>

<h2 className="mt-4 mh2">python upper case and lower case method:<br/></h2>

<h3 className="mt-4 mh3">python upper case upper()-</h3>
<p className="mt-4 para">The uppercase method uses to convert a string into an uppercase string.
</p>


<h2 className='headings'>Python Uppercase method Example Code:</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1"> ="</span>
                 <span className="qwerty-2">Ram</span>
                 <span className="qwerty-1">" </span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1">.</span>
                 <span className="qwerty-8">upper</span>
                 <span className="qwerty-6">()</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
             {"\n"}
                  </code>
         </pre>
         </div> 
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                        <span className="qwerty-10">RAM</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div>



<h2 className='headings'>Python Lowercase method Example Code:</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1"> ="</span>
                 <span className="qwerty-2">Ram</span>
                 <span className="qwerty-1">" </span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1">.</span>
                 <span className="qwerty-8">lower</span>
                 <span className="qwerty-6">()</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
             {"\n"}
                  </code>
         </pre>
         </div> 
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                        <span className="qwerty-10">ram</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div>

<h2 className="mt-4 mh2">Python String length:<br/></h2>
<p className="mt-4 para">Python String length to check the size of the string means to return the character of a series in the form of numbers.</p>



<h2 className='headings'>Python String Length method Example Code:</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-1"> ="</span>
                 <span className="qwerty-2">Code Exampler</span>
                 <span className="qwerty-1">" </span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-8">len</span>
                 <span className="qwerty-6">(</span>
                 <span className="qwerty-4">a</span>
                 <span className="qwerty-6">)</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
             {"\n"}
                  </code>
         </pre>
         </div> 
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
            <pre style={{maxHeight:"100vh"}}>
                <code >
                    {"\n"}
                        <span className="qwerty-3">13</span>
                        {"\n"}      {"\n"}      
              </code>
                </pre>
                </div>


  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/python-operators">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-control-structure">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Pstring;